import React from "react";

interface KitsProps {
  className?: string;
  width?: number;
  fill?: string;
  height?: number;
}
const IconKits: React.FC<KitsProps> = ({ className, width, height }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 48 48" fill="none">
    <g mask="url(#a)">
      <path
        d="M25 20v-4q0-.424.288-.713A.97.97 0 0 1 26 15h6q.424 0 .712.287.288.288.288.713v4q0 .424-.288.712A.97.97 0 0 1 32 21h-6a.97.97 0 0 1-.712-.288A.97.97 0 0 1 25 20m-10 4v-8q0-.424.287-.713A.97.97 0 0 1 16 15h6q.424 0 .712.287.288.288.288.713v8q0 .424-.288.712A.97.97 0 0 1 22 25h-6a.97.97 0 0 1-.713-.288A.97.97 0 0 1 15 24m10 8v-8q0-.424.288-.712A.97.97 0 0 1 26 23h6q.424 0 .712.288.288.287.288.712v8q0 .424-.288.712A.97.97 0 0 1 32 33h-6a.97.97 0 0 1-.712-.288A.97.97 0 0 1 25 32m-10 0v-4q0-.424.287-.712A.97.97 0 0 1 16 27h6q.424 0 .712.288.288.287.288.712v4q0 .424-.288.712A.97.97 0 0 1 22 33h-6a.97.97 0 0 1-.713-.288A.97.97 0 0 1 15 32m2-9h4v-6h-4zm10 8h4v-6h-4zm0-12h4v-2h-4zM17 31h4v-2h-4z"
        fill="#C2282B"
      />
    </g>
  </svg>
);
export default IconKits;
